import { render, staticRenderFns } from "./OsSetPasswordForm.vue?vue&type=template&id=2e1788a6&scoped=true"
import script from "./OsSetPasswordForm.vue?vue&type=script&lang=ts"
export * from "./OsSetPasswordForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1788a6",
  null
  
)

export default component.exports